module.exports = __webpack_public_path__ + "img/themes.88bc79bc.svg";